"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldLogic = exports.fieldsLogicRegistry = void 0;
exports.fieldsLogicRegistry = {};
function getFieldLogic(type) {
    return exports.fieldsLogicRegistry[type];
}
exports.getFieldLogic = getFieldLogic;
